import Vue from 'vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './plugins/store';
import '@/plugins/filters';
import '@/plugins/apexcharts';
import 'leaflet/dist/leaflet.css';

import App from './App.vue';
import './plugins/axios';
Vue.config.productionTip = false;

import { Icon } from 'leaflet';

type D = Icon.Default & {
	_getIconUrl: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const app = new Vue({
	el: '#app',
	render: (h) => h(App),
	vuetify,
	router,
	store,
});
